// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1231":"f12c2bc9","9401":"941160ed"}[chunkId] + ".chunk.css";
};